module.exports = __webpack_public_path__ + "img/logo-torbel-narvbar-fix.863e07d8.svg";